





































import { ResultsSectionView } from "@zoovu/runner-web-design-base";
import { Vue, Component } from "@zoovu/runner-browser-api";
import { isRecommendationBundles } from "@zoovu/runner-web-design-base/src/components/utils";

@Component({
  name: "ResultsSectionView",
  mixins: [ResultsSectionView],
})
export default class ResultsSectionViewExtended extends Vue<ResultsSectionView> {}
